import classnames from 'classnames';
import _ from 'lodash';
import { Record as record, List } from 'immutable';

import TOC from '../TOC';
import Station from '../Station';
import trainTime from '../../lib/TrainTime';
import Seat from './Seat';
import { TransitModes } from '../../constants/AppConstants';
import { resolve, resolveAll } from '../../helpers/LinkMapper';


const defaults = {
    id: null,
    origin: new Station(),
    destination: new Station(),
    departure: null,
    arrival: null,
    transferTime: null,
    mode: null,
    toc: null,
    facilities: new List(),
    seats: new List(),
    rsid: null,
    tuid: null,
    isTemporaryTrain: false
};

const LONDON_TERMINALS = "LT";

class OrderLeg extends record(defaults) {

    static fromJSON (json = {}) {
        const reducedFacilities = classnames(json.facilities).split(' ');

        return new OrderLeg({
            id: resolve(json.id).with(String),
            origin: resolve(json.origin).as(Station),
            destination: resolve(json.destination).as(Station),
            departure: resolve(json.departure).with(trainTime),
            arrival: resolve(json.arrival).with(trainTime),
            transferTime: resolve(json.transferTime).with(Number),
            mode: resolve(json.mode).with(String),
            toc: resolve(json.toc).as(TOC),
            facilities: resolveAll(_.compact(reducedFacilities)).with(String),
            seats: resolveAll(json.seats).as(Seat),
            rsid: resolve(json.rsid).with(String),
            tuid: resolve(json.tuid).with(String),
            isTemporaryTrain: resolve(json.isTemporaryTrain).with(Boolean)
        });
    }

    getTrainUid () {
        return this.get('tuid');
    }

    getSeats () {
        return this.get('seats').filterNot((seat) => seat.isCountedPlace());
    }

    hasCountedPlaceSeats() {
        return this.get('seats').some((seat) => seat.isCountedPlace());
    }

    isTrain () {
        return this.get('mode') === TransitModes.TRAIN;
    }

    hasSeats () {
        return this.isTrain() && this.getSeats().size;
    }

    isLondonTerminals () {
        return this.toc.code === LONDON_TERMINALS;
    }

    getIsMetro () {
        return this.mode === TransitModes.METRO;
    }

}


export default OrderLeg;



// WEBPACK FOOTER //
// ./src/records/order/Leg.js